import { useCallback, useEffect, useState } from 'react';
import { FundaeGroupingService } from '../../services/fundaeGrouping/fundaeGroupingService';

const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

const useFundaeGroupings = (initialFilters = {}) => {
    const [data, setData] = useState<any[]>([]);
    const [filters, setFilters] = useState({
        limit: 999999,
        filter_filters: {
            registration_date: getTodayDate(),
            ...initialFilters,
        }
    });

    const fetchFundaeGroupings = async () => {
        try {
            const service = new FundaeGroupingService();
            const response = await service.listForSelect(filters);
            const fetchedData = response.getResponseData()?.data;

            if (fetchedData && fetchedData?.data) {
                const mappedData = fetchedData.data?.map((item: { id: string; name: string }) => ({
                    value: item.id,
                    label: item.name,
                }));
                setData(mappedData);
            }
        } catch (error) {
            console.log('Error fetching Fundae groupings:', error);
        }
    };

    useEffect(() => {
        fetchFundaeGroupings();
    }, [filters]);

    const getFundaeGroupingsList = () => {
        return data;
    };

    const updateFundaeGroupingsHookFilters = useCallback((newFilters: any) => {
        setFilters((prevFilters) => ({
            ...prevFilters,
            filter_filters: {
                ...(prevFilters?.filter_filters ?? {}),
                ...newFilters,
            }
        }));
    }, []);

    return { fetchFundaeGroupings, getFundaeGroupingsList, updateFundaeGroupingsHookFilters };
};

export default useFundaeGroupings;
